import { render } from "./VideoPopupComponent.vue?vue&type=template&id=b6a5be40&scoped=true"
import script from "./VideoPopupComponent.vue?vue&type=script&lang=js"
export * from "./VideoPopupComponent.vue?vue&type=script&lang=js"

import "./VideoPopupComponent.vue?vue&type=style&index=0&id=b6a5be40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a5be40"]])

export default __exports__